export default {
  page: "Account"
};
